export default __webpack_public_path__ + "static/entremise-thumbnail-min-7aa020494c1b2a0572e7b9b6c7fb7a33.jpg";